import { Schema, arrayOf, unionOf } from 'normalizr';

export const achievementSchema = new Schema('achievements');
export const agreementSchema = new Schema('agreements');
export const apiUserSchema = new Schema('apiUsers');
export const areaSchema = new Schema('areas');
export const availableDateSchema = new Schema('availableDates');
export const availableDateSettingSchema = new Schema('availableDateSettings');
export const basicSchemaItemSchema = new Schema('basicSchemaItems');
export const basicSchemaSchema = new Schema('basicSchemas');
export const bookingInvoiceItemAttestedDateSchema = new Schema('bookingInvoiceItemAttestedDates');
export const bookingInvoiceItemBookedDateSchema = new Schema('bookingInvoiceItemBookedDates');
export const bookingInvoiceItemSchema = new Schema('bookingInvoiceItems');
export const bookingPaymentItemAttestedDateSchema = new Schema('bookingPaymentItemAttestedDates');
export const bookingPaymentItemBookedDateSchema = new Schema('bookingPaymentItemBookedDates');
export const bookingPaymentItemSchema = new Schema('bookingPaymentItems');
export const bookingResourceSchema = new Schema('bookingResources');
export const bookingSchema = new Schema('bookings');
export const budgetSchema = new Schema('budgets');
export const competencySchema = new Schema('competencies');
export const contactSchema = new Schema('contacts');
export const customerAgreementInvoiceSettingSchema = new Schema('customerAgreementInvoiceSettings');
export const customerAttestResourceSchema = new Schema('customerAttestResources');
export const customerAttestSchema = new Schema('customerAttests');
export const customerBjornLundenSettingSchema = new Schema('customerBjornLundenSettings');
export const customerFortnoxSettingSchema = new Schema('customerFortnoxSettings');
export const customerListSchema = new Schema('customerLists');
export const customerSchema = new Schema('customers');
export const daySchema = new Schema('days', { idAttribute: (day) => day.type });
export const documentTemplateSchema = new Schema('documentTemplates');
export const domainSchema = new Schema('domains');
export const emailSchema = new Schema('emails', { idAttribute: (email) => email.subject });
export const employmentContractPreviewSchema = new Schema('employmentContractPreviews');
export const employmentContractSchema = new Schema('employmentContracts');
export const employmentNumberSchema = new Schema('employmentNumbers');
export const entityViewSchema = new Schema('entityViews');
export const eventSchema = new Schema('events');
export const expenseSchema = new Schema('expenses');
export const fileSchema = new Schema('files');
export const geoCodeSchema = new Schema('geoCodes');
export const holidaySchema = new Schema('holidays', { idAttribute: (entity) => entity.date });
export const inquirySchema = new Schema('inquiries');
export const internalTimeReportSchema = new Schema('internalTimeReports');
export const invoiceAddressSchema = new Schema('invoiceAddresses');
export const invoiceDeliveryTypeSchema = new Schema('invoiceDeliveryTypes', { idAttribute: (entity) => entity.type });
export const invoiceDetailSchema = new Schema('invoiceDetails');
export const invoiceSchema = new Schema('invoices');
export const itemsSchema = new Schema('items');
export const jobBoardSchema = new Schema('jobBoards', { idAttribute: (entity) => entity.type });
export const mileageAllowanceSchema = new Schema('mileageAllowances');
export const minimalBookingSchema = new Schema('bookings');
export const municipalitySchema = new Schema('municipalities');
export const occupationNameSchema = new Schema('occupationNames');
export const oneflowCollectionSchema = new Schema('oneflowCollections');
export const oneflowTemplateSchema = new Schema('oneflowTemplates');
export const paginatedItemsSchema = new Schema('paginatedItems');
export const paymentCollectionSchema = new Schema('paymentCollections');
export const paymentRowSchema = new Schema('paymentRows');
export const paymentSchema = new Schema('payments');
export const periodsAndBookingsSchema = new Schema('periodsAndBookings');
export const periodSchema = new Schema('periodSchema');
export const personSchema = new Schema('people');
export const previewBookingSmsSchema = new Schema('previewBookingSmses', { idAttribute: (sms) => sms.phoneNumber });
export const pricePeriodSchema = new Schema('pricePeriods',
  { idAttribute: (pricePeriod) => `${pricePeriod.date}_${pricePeriod.from}` });
export const publicTimeReportSchema = new Schema('publicTimeReports');
export const qualifyingDeductionSchema = new Schema('qualifyingDeductions');
export const questionnaireSchema = new Schema('questionnaire');
export const recruitmentAdApplicationSchema = new Schema('recruitmentAdApplications');
export const recruitmentAdContactSchema = new Schema('recruitmentAdContacts');
export const recruitmentAdSchema = new Schema('recruitmentAds');
export const recruitmentStatusSchema = new Schema('recruitmentStatuses');
export const replacementModelSchema = new Schema('replacementModels');
export const resourceFortnoxSettingSchema = new Schema('resourceFortnoxSettings');
export const resourceListSchema = new Schema('resourceLists');
export const resourceSchema = new Schema('resources');
export const serviceSchema = new Schema('services');
export const signableDocumentSchema = new Schema('signableDocuments');
export const pushNotificationSchema = new Schema('pushNotifications');
export const smsSchema = new Schema('smses');
export const staffingCompanyGroupSchema = new Schema('staffingCompanyGroups');
export const staffingCompanyGroupUsageSchema = new Schema('staffingCompanyGroupUsages');
export const staffingCompanySchema = new Schema('staffingCompanies');
export const statisticSchema = new Schema('statistics');
export const statusSchema = new Schema('statuses');
export const taskSchema = new Schema('tasks');
export const termSchema = new Schema('terms');
export const timeplanUnitSchema = new Schema('timeplanUnits');
export const timeReportSchema = new Schema('timeReports');
export const userSchema = new Schema('users');
export const weeklyTimeReportSummary = new Schema('weeklyTimeReportSummaries');
export const workTypeSchema = new Schema('workTypes');
export const weeklyBookingSchema = new Schema(
  'weeklyBookings',
  {
    idAttribute: (entity) => `${entity.booking.id}_${entity.resource.id}_${entity.year}_${entity.week}`,
  },
);

// Relations
serviceSchema.define({
  children: arrayOf(serviceSchema),
});

competencySchema.define({
  children: arrayOf(competencySchema),
});

signableDocumentSchema.define({
  createdBy: userSchema,
  resource: resourceSchema,
  files: arrayOf(fileSchema),
});

pushNotificationSchema.define({
  createdBy: userSchema,
  resource: resourceSchema,
});

documentTemplateSchema.define({
  createdBy: userSchema,
  staffingCompanyGroup: staffingCompanyGroupSchema,
});

agreementSchema.define({
  createdBy: userSchema,
  customer: customerSchema,
  resource: resourceSchema,
  replacementModels: arrayOf(replacementModelSchema),
  staffingCompany: staffingCompanySchema,
  files: arrayOf(fileSchema),
  invoiceSettings: arrayOf(customerAgreementInvoiceSettingSchema),
  workTypes: arrayOf(workTypeSchema),
});

areaSchema.define({
  geoCode: geoCodeSchema,
});

basicSchemaSchema.define({
  createdBy: userSchema,
  items: arrayOf(basicSchemaItemSchema),
});

bookingInvoiceItemSchema.define({
  attestedDates: arrayOf(bookingInvoiceItemAttestedDateSchema),
  bookedDates: arrayOf(bookingInvoiceItemBookedDateSchema),
  booking: bookingSchema,
  resource: resourceSchema,
});

bookingPaymentItemSchema.define({
  attestedDates: arrayOf(bookingPaymentItemAttestedDateSchema),
  bookedDates: arrayOf(bookingPaymentItemBookedDateSchema),
  booking: bookingSchema,
  resource: resourceSchema,
});

mileageAllowanceSchema.define({
  booking: bookingSchema,
  resource: resourceSchema,
  payment: paymentSchema,
});

customerAgreementInvoiceSettingSchema.define({
  customer: customerSchema,
});

customerAttestResourceSchema.define({
  resource: resourceSchema,
});

customerAttestSchema.define({
  person: personSchema,
  customerAttestResources: arrayOf(customerAttestResourceSchema),
});

contactSchema.define({
  person: personSchema,
  customer: customerSchema,
});

paymentSchema.define({
  bookingPaymentItemAttestedDates: arrayOf(bookingPaymentItemAttestedDateSchema),
  bookingReportPeriodPaymentCredits: arrayOf(timeplanUnitSchema),
  bookingReportPeriods: arrayOf(timeplanUnitSchema),
  createdBy: userSchema,
  paymentRows: arrayOf(paymentRowSchema),
  mileageAllowances: arrayOf(mileageAllowanceSchema),
  resource: resourceSchema,
  staffingCompany: staffingCompanySchema,
});

paymentCollectionSchema.define({
  createdBy: userSchema,
});

apiUserSchema.define({
  createdBy: userSchema,
});

replacementModelSchema.define({
  // periods: arrayOf(periodSchema),
  term: termSchema,
});

periodSchema.define({
  // workType: workTypeSchema,
});

personSchema.define({
  createdBy: userSchema,
  contacts: arrayOf(contactSchema),
});

inquirySchema.define({
  createdBy: userSchema,
  customer: customerSchema,
  services: arrayOf(serviceSchema),
  files: arrayOf(fileSchema),
  ad: {
    user: userSchema,
  },
});

invoiceSchema.define({
  createdBy: userSchema,
  customer: customerSchema,
  customerAgreement: agreementSchema,
  details: arrayOf(invoiceDetailSchema),
  recipient: invoiceAddressSchema,
  staffingCompany: staffingCompanySchema,
  timeplanUnits: arrayOf(timeplanUnitSchema),
});

weeklyBookingSchema.define({
  resource: resourceSchema,
  booking: minimalBookingSchema,
  services: arrayOf(serviceSchema),
  customer: customerSchema,
  staffingCompany: staffingCompanySchema,
  createdBy: userSchema,
});

employmentContractSchema.define({
  createdBy: userSchema,
  files: arrayOf(fileSchema),
  resource: resourceSchema,
  signedByUser: userSchema,
  staffingCompany: staffingCompanySchema,
});

bookingSchema.define({
  attestBy: personSchema,
  bookingResources: arrayOf(bookingResourceSchema),
  customerAgreement: agreementSchema,
  files: arrayOf(fileSchema),
  createdBy: userSchema,
  customer: customerSchema,
  staffingCompany: staffingCompanySchema,
  services: arrayOf(serviceSchema),
  contact: personSchema,
  purchaser: personSchema,
  parent: bookingSchema,
});

bookingResourceSchema.define({
  resource: resourceSchema,
  files: arrayOf(fileSchema),
  resourceAgreement: agreementSchema,
  workTypes: arrayOf(workTypeSchema),
  customerReplacementModel: replacementModelSchema,
  resourceReplacementModel: replacementModelSchema,
  invoiceItems: arrayOf(bookingInvoiceItemSchema),
  paymentItems: arrayOf(bookingPaymentItemSchema),
});

qualifyingDeductionSchema.define({
  createdBy: userSchema,
});

recruitmentAdApplicationSchema.define({
  resource: resourceSchema,
});

recruitmentAdSchema.define({
  contacts: arrayOf(recruitmentAdContactSchema),
  createdBy: userSchema,
  jobBoards: arrayOf(jobBoardSchema),
  municipality: municipalitySchema,
  occupation: occupationNameSchema,
  questionnaire: questionnaireSchema,
  service: serviceSchema,
  staffingCompany: staffingCompanySchema,
  user: userSchema,
});

customerBjornLundenSettingSchema.define({
  staffingCompany: staffingCompanySchema,
});

resourceFortnoxSettingSchema.define({
  staffingCompany: staffingCompanySchema,
});

customerFortnoxSettingSchema.define({
  staffingCompany: staffingCompanySchema,
});

resourceSchema.define({
  areas: arrayOf(areaSchema),
  availableDates: arrayOf(availableDateSchema),
  basicSchema: arrayOf(timeplanUnitSchema),
  bookedPeriods: arrayOf(timeplanUnitSchema),
  files: arrayOf(fileSchema),
  fortnoxSettings: arrayOf(resourceFortnoxSettingSchema),
  lastInteractionEvent: eventSchema,
  lastRecruitmentCommentEvent: eventSchema,
  latestBookings: arrayOf(bookingSchema),
  owningUser: userSchema,
  recruitmentStatus: recruitmentStatusSchema,
  relatedBookings: arrayOf(bookingSchema),
  reportedPeriods: arrayOf(timeplanUnitSchema),
  resourceReportedPeriods: arrayOf(timeplanUnitSchema),
  services: arrayOf(serviceSchema),
  status: statusSchema,
  unconfirmedBookedPeriods: arrayOf(timeplanUnitSchema),
  employmentNumbers: arrayOf(employmentNumberSchema),
});

customerSchema.define({
  agreements: arrayOf(agreementSchema),
  contacts: arrayOf(contactSchema),
  files: arrayOf(fileSchema),
  owningUser: userSchema,
  hierarchy: arrayOf(customerSchema),
  children: arrayOf(customerSchema),
  parent: customerSchema,
  lastInteractionEvent: eventSchema,
  fortnoxSettings: arrayOf(customerFortnoxSettingSchema),
  bjornLundenSettings: arrayOf(customerBjornLundenSettingSchema),
});

employmentNumberSchema.define({
  staffingCompany: staffingCompanySchema,
});

fileSchema.define({
  createdBy: userSchema,
});

taskSchema.define({
  assignee: userSchema,
  completedBy: userSchema,
  createdBy: userSchema,
});

smsSchema.define({
  resources: arrayOf(resourceSchema),
});

staffingCompanyGroupSchema.define({
  availableDateSetting: availableDateSettingSchema,
  domains: arrayOf(domainSchema),
  staffingCompanies: arrayOf(staffingCompanySchema),
});

timeReportSchema.define({
  periods: arrayOf(timeplanUnitSchema),
  resource: resourceSchema,
});

timeplanUnitSchema.define({
  workType: workTypeSchema,
  resource: resourceSchema,
  customer: customerSchema,
  booking: bookingSchema,
  payment: paymentSchema,
  invoice: invoiceSchema,
  customerAttest: customerAttestSchema,
});

publicTimeReportSchema.define({
  bookings: arrayOf(bookingSchema),
  bookedPeriods: arrayOf(timeplanUnitSchema),
  resourceReportedPeriods: arrayOf(timeplanUnitSchema),
  resourceOwner: userSchema,
});

internalTimeReportSchema.define({
  bookedPeriods: arrayOf(timeplanUnitSchema),
  bookingInvoiceItems: arrayOf(bookingInvoiceItemSchema),
  bookingPaymentItems: arrayOf(bookingPaymentItemSchema),
  bookings: arrayOf(bookingSchema),
  customerAttests: arrayOf(customerAttestSchema),
  mileageAllowances: arrayOf(mileageAllowanceSchema),
  reportedPeriods: arrayOf(timeplanUnitSchema),
  resources: arrayOf(resourceSchema),
  timeReports: arrayOf(timeReportSchema),
});

periodsAndBookingsSchema.define({
  periods: arrayOf(timeplanUnitSchema),
  bookings: arrayOf(bookingSchema),
});

export const EntityTypes = {
  Achievement: 'Achievement',
  Agreement: 'Agreement',
  ApiUser: 'ApiUser',
  Area: 'Area',
  AvailableDate: 'AvailableDate',
  AvailableDateSetting: 'AvailableDateSetting',
  BasicSchema: 'BasicSchema',
  BasicSchemaItem: 'BasicSchemaItem',
  Booking: 'Booking',
  BookingInvoiceItem: 'BookingInvoiceItem',
  BookingInvoiceItemAttestedDate: 'BookingInvoiceItemAttestedDate',
  BookingInvoiceItemBookedDate: 'BookingInvoiceItemBookedDate',
  BookingPaymentItem: 'BookingPaymentItem',
  BookingPaymentItemAttestedDate: 'BookingPaymentItemAttestedDate',
  BookingPaymentItemBookedDate: 'BookingPaymentItemBookedDate',
  BookingResource: 'BookingResource',
  Budget: 'Budget',
  Customer: 'Customer',
  CustomerAgreementInvoiceSetting: 'CustomerAgreementInvoiceSetting',
  CustomerAttest: 'CustomerAttest',
  CustomerAttestResource: 'CustomerAttestResource',
  CustomerFortnoxSetting: 'CustomerFortnoxSetting',
  CustomerBjornLundenSetting: 'CustomerBjornLundenSetting',
  CustomerList: 'CustomerList',
  Day: 'Day',
  DocumentTemplate: 'DocumentTemplate',
  Domain: 'Domain',
  Email: 'Email',
  EmploymentContract: 'EmploymentContract',
  EmploymentContractPreview: 'EmploymentContractPreview',
  EmploymentNumber: 'EmploymentNumber',
  EntityView: 'EntityView',
  Event: 'Event',
  Expense: 'Expense',
  GeoCode: 'GeoCode',
  Holiday: 'Holiday',
  Inquiry: 'Inquiry',
  InternalTimeReport: 'InternalTimeReport',
  Invoice: 'Invoice',
  InvoiceAddress: 'InvoiceAddress',
  InvoiceDeliveryType: 'InvoiceDeliveryType',
  Items: 'Items',
  JobBoard: 'JobBoard',
  MileageAllowance: 'MileageAllowance',
  Municipality: 'Municipality',
  OccupationName: 'OccupationName',
  OneflowCollection: 'OneflowCollection',
  OneflowTemplate: 'OneflowTemplate',
  PaginatedItems: 'PaginatedItems',
  Payment: 'Payment',
  PaymentCollection: 'PaymentCollection',
  PaymentRow: 'PaymentRow',
  PeriodsAndBookings: 'PeriodsAndBookings',
  Person: 'Person',
  PreviewBookingSms: 'PreviewBookingSms',
  PricePeriod: 'PricePeriod',
  PublicTimeReport: 'PublicTimeReport',
  QualifyingDeduction: 'QualifyingDeduction',
  Questionnaire: 'Questionnaire',
  RecruitmentAd: 'RecruitmentAd',
  RecruitmentAdApplication: 'RecruitmentAdApplication',
  RecruitmentAdContact: 'RecruitmentAdContact',
  RecruitmentStatus: 'RecruitmentStatus',
  ReplacementModel: 'ReplacementModel',
  Resource: 'Resource',
  ResourceFortnoxSetting: 'ResourceFortnoxSetting',
  ResourceList: 'ResourceList',
  Service: 'Service',
  SignableDocument: 'SignableDocument',
  PushNotification: 'PushNotification',
  Sms: 'Sms',
  StaffingCompany: 'StaffingCompany',
  StaffingCompanyGroup: 'StaffingCompanyGroup',
  StaffingCompanyGroupUsage: 'StaffingCompanyGroupUsage',
  Statistic: 'Statistic',
  Task: 'Task',
  Term: 'Term',
  TimeplanUnit: 'TimeplanUnit',
  TimeReport: 'TimeReport',
  User: 'User',
  WeeklyBooking: 'WeeklyBooking',
  WeeklyTimeReportSummary: 'WeeklyTimeReportSummary',
  WorkType: 'WorkType',
};

const EntitySchemaTypes = {
  [EntityTypes.Achievement]: achievementSchema,
  [EntityTypes.Agreement]: agreementSchema,
  [EntityTypes.ApiUser]: apiUserSchema,
  [EntityTypes.Area]: areaSchema,
  [EntityTypes.AvailableDate]: availableDateSchema,
  [EntityTypes.AvailableDateSetting]: availableDateSettingSchema,
  [EntityTypes.BasicSchema]: basicSchemaSchema,
  [EntityTypes.BasicSchemaItem]: basicSchemaItemSchema,
  [EntityTypes.Booking]: bookingSchema,
  [EntityTypes.BookingInvoiceItem]: bookingInvoiceItemSchema,
  [EntityTypes.BookingInvoiceItemAttestedDate]: bookingInvoiceItemAttestedDateSchema,
  [EntityTypes.BookingInvoiceItemBookedDate]: bookingInvoiceItemBookedDateSchema,
  [EntityTypes.BookingPaymentItem]: bookingPaymentItemSchema,
  [EntityTypes.BookingPaymentItemAttestedDate]: bookingPaymentItemAttestedDateSchema,
  [EntityTypes.BookingPaymentItemBookedDate]: bookingPaymentItemBookedDateSchema,
  [EntityTypes.BookingResource]: bookingResourceSchema,
  [EntityTypes.Budget]: budgetSchema,
  [EntityTypes.Customer]: customerSchema,
  [EntityTypes.CustomerAgreementInvoiceSetting]: customerAgreementInvoiceSettingSchema,
  [EntityTypes.CustomerAttest]: customerAttestSchema,
  [EntityTypes.CustomerAttestResource]: customerAttestResourceSchema,
  [EntityTypes.CustomerBjornLundenSetting]: customerBjornLundenSettingSchema,
  [EntityTypes.CustomerFortnoxSetting]: customerFortnoxSettingSchema,
  [EntityTypes.CustomerList]: customerListSchema,
  [EntityTypes.Day]: daySchema,
  [EntityTypes.DocumentTemplate]: documentTemplateSchema,
  [EntityTypes.Domain]: domainSchema,
  [EntityTypes.Email]: emailSchema,
  [EntityTypes.EmploymentContract]: employmentContractSchema,
  [EntityTypes.EmploymentContractPreview]: employmentContractPreviewSchema,
  [EntityTypes.EmploymentNumber]: employmentNumberSchema,
  [EntityTypes.EntityView]: entityViewSchema,
  [EntityTypes.Event]: eventSchema,
  [EntityTypes.Expense]: expenseSchema,
  [EntityTypes.GeoCode]: geoCodeSchema,
  [EntityTypes.Holiday]: holidaySchema,
  [EntityTypes.Inquiry]: inquirySchema,
  [EntityTypes.InternalTimeReport]: internalTimeReportSchema,
  [EntityTypes.Invoice]: invoiceSchema,
  [EntityTypes.InvoiceAddress]: invoiceAddressSchema,
  [EntityTypes.InvoiceDeliveryType]: invoiceDeliveryTypeSchema,
  [EntityTypes.Items]: itemsSchema,
  [EntityTypes.JobBoard]: jobBoardSchema,
  [EntityTypes.MileageAllowance]: mileageAllowanceSchema,
  [EntityTypes.Municipality]: municipalitySchema,
  [EntityTypes.OccupationName]: occupationNameSchema,
  [EntityTypes.OneflowCollection]: oneflowCollectionSchema,
  [EntityTypes.OneflowTemplate]: oneflowTemplateSchema,
  [EntityTypes.PaginatedItems]: paginatedItemsSchema,
  [EntityTypes.Payment]: paymentSchema,
  [EntityTypes.PaymentCollection]: paymentCollectionSchema,
  [EntityTypes.PaymentRow]: paymentRowSchema,
  [EntityTypes.PeriodsAndBookings]: periodsAndBookingsSchema,
  [EntityTypes.Person]: personSchema,
  [EntityTypes.PreviewBookingSms]: previewBookingSmsSchema,
  [EntityTypes.PricePeriod]: pricePeriodSchema,
  [EntityTypes.PublicTimeReport]: publicTimeReportSchema,
  [EntityTypes.QualifyingDeduction]: qualifyingDeductionSchema,
  [EntityTypes.Questionnaire]: questionnaireSchema,
  [EntityTypes.RecruitmentAd]: recruitmentAdSchema,
  [EntityTypes.RecruitmentAdApplication]: recruitmentAdApplicationSchema,
  [EntityTypes.RecruitmentAdContact]: recruitmentAdContactSchema,
  [EntityTypes.RecruitmentStatus]: recruitmentStatusSchema,
  [EntityTypes.ReplacementModel]: replacementModelSchema,
  [EntityTypes.Resource]: resourceSchema,
  [EntityTypes.ResourceFortnoxSetting]: resourceFortnoxSettingSchema,
  [EntityTypes.ResourceList]: resourceListSchema,
  [EntityTypes.Service]: serviceSchema,
  [EntityTypes.SignableDocument]: signableDocumentSchema,
  [EntityTypes.PushNotification]: pushNotificationSchema,
  [EntityTypes.Sms]: smsSchema,
  [EntityTypes.StaffingCompany]: staffingCompanySchema,
  [EntityTypes.StaffingCompanyGroup]: staffingCompanyGroupSchema,
  [EntityTypes.StaffingCompanyGroupUsage]: staffingCompanyGroupUsageSchema,
  [EntityTypes.Statistic]: statisticSchema,
  [EntityTypes.Task]: taskSchema,
  [EntityTypes.Term]: termSchema,
  [EntityTypes.TimeplanUnit]: timeplanUnitSchema,
  [EntityTypes.TimeReport]: timeReportSchema,
  [EntityTypes.User]: userSchema,
  [EntityTypes.WeeklyBooking]: weeklyBookingSchema,
  [EntityTypes.WeeklyTimeReportSummary]: weeklyTimeReportSummary,
  [EntityTypes.WorkType]: workTypeSchema,
};


export const entitySchema = unionOf(EntitySchemaTypes, { schemaAttribute: '_type' });

entityViewSchema.define({
  entity: entitySchema,
});

itemsSchema.define({
  items: arrayOf(entitySchema),
});

paginatedItemsSchema.define({
  items: arrayOf(entitySchema),
});

export const ListTypes = [
  EntityTypes.Items,
  EntityTypes.PaginatedItems,
];

eventSchema.define({
  createdBy: userSchema,
  flaggedBy: userSchema,
  files: arrayOf(fileSchema),
  entity: entitySchema,
});
